export default "__VITE_ASSET__K0R7GqjR__"